<template>
  <div>
    <!-- {{ model }} -->
    <b-table-simple hover small caption-top responsive style="max-width: 600px">
      <b-thead>
        <b-tr>
          <b-th v-for="field in header" :key="field.label">
            {{ field.label }}
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td>
            <label for="entryPhoto">FOTO DE ENTRADA</label>
          </b-td>
          <b-td>
            <b-form-checkbox
              id="isMandatoryEntryPhoto"
              v-model="model.isMandatoryEntryPhoto"
            >
            </b-form-checkbox>
          </b-td>
          <b-td></b-td>
        </b-tr>
        <b-tr>
          <b-td>
            <label for="workshopName">LOCAL DA MANUTENÇÃO </label>
          </b-td>
          <b-td></b-td>
          <b-td>
            <div>
              <b-form-checkbox
                class="mb-2"
                id="internal"
                v-model="model.internal"
              >
                INTERNO
              </b-form-checkbox>
              <b-form-checkbox id="external" v-model="model.external">
                EXTERNO
              </b-form-checkbox>
            </div>
            <span v-if="!hasValue()" class="text-warning">SELECIONE UM</span>
          </b-td>
        </b-tr>
        <b-tr v-if="model.external">
          <b-td>
            <label for="workshopName">OFICINA</label>
          </b-td>
          <b-td>
            <b-form-checkbox
              id="isMandatoryWorkshopName"
              v-model="model.isMandatoryWorkshopName"
            >
            </b-form-checkbox>
          </b-td>
          <b-td></b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  name: "RevisionEntryConfigurationCrud",
  props: {
    model: Object,
    submitted: Boolean,
  },
  data() {
    return {
      header: [
        {
          label: "Nome",
        },
        {
          label: "Obrigatório",
        },
        {
          label: "Valores",
        },
      ],
    };
  },
  methods: {
    hasValue() {
      if (this.model.internal || this.model.external) {
        this.$emit("update:submitted", false);
        return true;
      }
      this.$emit("update:submitted", true);
      return false;
    },
  },
  computed: {},
};
</script>

<style scoped>
/* Your styles here */
</style>